import { useState } from "react";
import Helpers from "../Config/Helpers";
import axios from 'axios';
import loginHero from "../images/updatedHero.png";
import "./Login.css";
import { useLocation } from "react-router-dom";

function Login() {
  const location = useLocation();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const normalizeShop = (shop = {}) => {
    const address =
      shop.address ||
      shop.shop_address ||
      shop.full_address ||
      [shop.address_line1, shop.address_line2, shop.city, shop.state, shop.zip]
        .filter(Boolean)
        .join(", ");
    const phone = shop.phone || shop.shop_phone || shop.contact_phone || "";
    return { ...shop, address, phone };
  };
  const hanldeLogin = async (e) => {
    e.preventDefault();
    axios.post(`${Helpers.baseUrl}/users/login-user`, formData).then(response => {
        const redirectTo = Helpers.isCheckInOnlyUser(response.data.user)
          ? "/checkin"
          : location.state?.from || "/user/dashboard";
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('timestamp', new Date().getTime());
        localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
        Helpers.toast("success", "Logged In successfully");
        axios
          .get(`${Helpers.baseUrl}/shops/current`, {
            headers: {
              "Content-Type": "application/json",
              "x-access-token": response.data.token,
            },
          })
          .then((shopResponse) => {
            const normalizedShop = normalizeShop(shopResponse.data || {});
            localStorage.setItem("shop", JSON.stringify(normalizedShop));
          })
          .catch(() => {
            localStorage.removeItem("shop");
          })
          .finally(() => {
            window.location.href = redirectTo;
          });
    }).catch(error => {
        setErrors(Helpers.error_response(error));
    });
  };

  return (
    <main className="login-page">
      <section className="login-panel" aria-label={`${Helpers.appName} login`}>
        <div className="login-form-column">
          <div className="login-form-wrap">
            <a href="/" className="login-brand" aria-label="Vyrex Systems">
              <span>Vyrex</span>
              <span>Systems</span>
            </a>

            <form className="login-form" onSubmit={hanldeLogin}>
              <h1>Sign in</h1>

              <div className="login-field">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  autoComplete="email"
                />
                {errors.email ? <small>{errors.email}</small> : null}
              </div>

              <div className="login-field">
                <label htmlFor="password-input">Password</label>
                <div className="login-password-control">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={(e) =>
                      setFormData({ ...formData, password: e.target.value })
                    }
                    autoComplete="current-password"
                    id="password-input"
                  />
                  <button
                    type="button"
                    className="login-password-toggle"
                    onClick={() => setShowPassword((isShown) => !isShown)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
                {errors.password ? <small>{errors.password}</small> : null}
              </div>

              <button className="login-submit" type="submit">
                Sign In
              </button>

              <a href="auth-pass-reset-basic.html" className="login-forgot-link">
                Forgot password?
              </a>
            </form>
          </div>
        </div>

        <div className="login-hero-column">
          <img src={loginHero} alt="Automotive service dashboard illustration" />
        </div>
      </section>
    </main>
  );
}

export default Login;
